import React from 'react';
import Cookies from 'js-cookie';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useRouter } from 'next/router';
import { getApiClient } from '../services/api/apiClient';
import { protocol } from './config';

export const LOGIN_REDIRECT_COOKIE = 'loginredirect';

const authenticationRequiredOptions = {
  returnTo: process.env.NEXT_PUBLIC_AUTH0_CALLBACK_URL,
  // eslint-disable-next-line react/display-name
  onRedirecting: () => {
    return <div></div>;
  },
};

export const getToken = (BaseComponent) => () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const apiClient = getApiClient();

  getAccessTokenSilently()
    .then((token) => {
      const tenant = user[process.env.NEXT_PUBLIC_AUTH0_TENANT_CLAIM];
      return apiClient.initialize(token, tenant);
    })
    .catch(() => {
      console.error('failed to get token');
    });

  return <BaseComponent />;
};

export const getRedirectCookieValue = (router) => {
  let cookieValue;
  if (router?.pathname) {
    const { pathname } = router;
    const ids = pathname.match(/(\[).+?(\])/);
    if (ids?.length) {
      const id = ids[0].substring(1, ids[0].length - 1);
      const value = router.query[id];
      cookieValue = pathname.replace(`[${id}]`, value);
    } else {
      cookieValue = pathname;
    }
  }

  return cookieValue;
};

export const setRedirectCookie = (BaseComponent) => () => {
  if (typeof window === 'undefined') {
    return <BaseComponent />;
  }

  const router = useRouter();
  const cookieValue = getRedirectCookieValue(router);

  Cookies.set(LOGIN_REDIRECT_COOKIE, cookieValue, {
    path: '/',
    expires: 1,
  });

  return <BaseComponent />;
};

const withTokenRequired = (BaseComponent) => {
  return setRedirectCookie(
    withAuthenticationRequired(
      getToken(BaseComponent),
      authenticationRequiredOptions
    )
  );
};

export default withTokenRequired;
